import { graphql } from "@/lib/gql/__generated__";

export const VoucherIssuedMarkVoucherAsUsed_ECReceiptDetailPage_Mutation = graphql(`
	mutation VoucherIssuedMarkVoucherAsUsed_ECReceiptDetailPage($input: VoucherIssuedMarkVoucherAsUsedInput!) {
		voucherIssuedMarkVoucherAsUsed(input: $input) {
			userErrors
			voucherIssued {
				hotelID
				voucherCode
				userECReceiptID
				usedReservationID
				useableStartDt
				cinStart
				cinEnd
				guestName
				guestEmail
				guestPostalCode
				guestAddress
				guestTel
				giftInfo {
					to
					from
					password
					message
				}
				createdAt
				createdDt
				usedAt
			}
		}
	}
`);
